type Counts = { [key: string]: number | undefined };

// The API sends an explicit 0 for a facet with no hotels, so a key is normally there once it answered;
// a missing key is still read as 0 rather than "unknown", so the option greys out instead of vanishing.
export const counterOf = (counts: Counts | undefined, key: string | number): number | undefined =>
  counts ? (counts[key] ?? 0) : undefined;

// A selected option stays clickable so the user can always clear it.
export const disabledAtZero = (selected: boolean, counter: number | undefined): boolean => !selected && counter === 0;

// A selected value is never dropped: without its option there is no badge and no reset button.
export const keysWithSelected = (answered: string[], selectedValues: string[]): string[] => [
  ...new Set([...answered, ...selectedValues]),
];
